@if (show) {
<div class="loading" [class.overlay]="overlay" [attr.aria-label]="ariaLabel">
  <mat-spinner [diameter]="diameter"></mat-spinner>
  @if (message) {
  <div class="message">{{ message }}</div>
  }
</div>
}